import { IInquiryKind } from "@Types/inquiry";
import styles from "../../../pages/ask/price.module.less";

import { activityAtom } from "@Lib/jotai/activity";
import { IKindsPcInfo } from "@Types/kindsum";
import { useHover, useSetState } from "ahooks";
import { useAtom } from "jotai";
import React, { useEffect, useMemo, useRef, useState } from "react";

const TagItem: React.FC<any> = ({ tag = "廠商優惠", type }) => {
  if (type === "roster") {
    return (
      <div className='text-[#FF4333] pr-4'>
        <div
          className='text-12 rounded-4 w-58 flex leading-20 justify-center h-20'
          style={{ border: "0.5px solid #FF4333" }}
        >
          {tag}
        </div>
      </div>
    );
  }
  return (
    <div className='bg-[#FFDFD6] text-12 whitespace-pre rounded-4 w-58 flex items-center justify-center h-20 text-[#D92A21]'>
      {tag}
    </div>
  );
};

const Item: React.FC<any> = ({ label, content }) => {
  return (
    <div className='flex gap-4 mt-2'>
      {!!label && <div className='text-[#999] whitespace-pre'>{label}：</div>}
      <div className='text-black' style={{ maxWidth: "230px" }}>
        {content}
      </div>
    </div>
  );
};

const arr = [
  { value: "cashDiscount", label: "現折" },
  { value: "loanDiscount", label: "貸款" },
  { value: "subsidyDiscount", label: "補貼" },
  { value: "warrantyDiscount", label: "保固" },
  { value: "insuranceDiscount", label: "保險" },
  { value: "maintenanceDiscount", label: "保養" },
  { value: "giftDiscount", label: "禮品" },
  { value: "otherDiscount", label: "其他" },
  // { value: "remark", label: "备注" },
];

const OneBrand: React.FC<{
  factoryDiscount: IKindsPcInfo["factoryDiscount"];
  type: string;
  params: { value: string; label: string }[];
}> = ({ factoryDiscount, type, params }) => {
  const { remark, title = "", tag } = factoryDiscount;

  return (
    <div
      className='w-350 flex justify-center  absolute bottom-0 left-12 z-99 rounded-8 cursor-pointer'
      style={{ boxShadow: "0px 4px 20px 0px rgba(0,0,0,0.10)" }}
    >
      <div id={"OneBrand"} className='rounded-8 overflow-hidden'>
        <div
          className={`w-full h-36 flex items-center px-10 ${title ? "justify-center" : "justify-start"} `}
          style={{
            background: "linear-gradient(180deg,#ffece9, #fff9f8)",
            borderBottom: "0.5px solid rgb(255 201 186 / 47%)",
          }}
        >
          <div className={`flex gap-8 text-14 text-black`}>
            {!title && <TagItem tag={tag} type={type} />}
            <span className='font-[500]'>{title}</span>
          </div>
        </div>
        <div className='p-10 bg-[#FFFDFC] flex flex-wrap gap-10'>
          <div className='flex gap-10 text-12'>
            {type === "roster" && title && <TagItem tag={tag} type={type} />}
            <div className='grid gap-6 flex-warp' style={{ maxWidth: "260px", flexWrap: "wrap" }}>
              {params.map((item: any, index: number) => (
                <Item label={item.label} content={item.value} key={index} />
              ))}
            </div>
          </div>

          <div className='w-350 text-right text-10 text-[#999] pl-66 flex justify-end'>
            <div className='text-left'>{remark}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
const DiscountBanner: React.FC<any> = ({ factoryDiscount, type }) => {
  const ref = useRef(null);
  const isHovering = useHover(ref);
  const { tag = "廠商優惠", title, remark } = factoryDiscount;

  const params = useMemo(() => {
    const result = [] as { value: string; label: string }[];
    arr.map((item: any, index: number) => {
      if (!!factoryDiscount[item.value]) {
        result.push({
          value: factoryDiscount[item.value],
          label: item.label,
        });
      }
    });
    factoryDiscount.extra.map((item: any, index: number) => {
      result.push({
        value: item.value,
        label: item.key,
      });
    });
    return result;
  }, [factoryDiscount]);

  return (
    <div className='w-400 relative ml-20'>
      <img
        className='h-9 absolute z-99'
        style={{ width: "15px", top: "-0.7px", right: "-13px" }}
        src='https://photo.8891.com.tw/2024/10/14/1728873701420230.png'
      />
      <div
        className='w-full rounded-4 relative bg-[#fffaf9] px-10 py-10'
        style={{ border: "1px solid #ff4433", borderRadius: "4px 0 4px 4px" }}
      >
        <div className='relative' ref={ref}>
          {isHovering && params.length > 3 && (
            <OneBrand factoryDiscount={factoryDiscount} type={type} params={params} />
          )}

          <div id='AKindSumRightDiscount' className='w-full bg-cover bg-no-repeat flex relative flex-wrap flex-col'>
            <div className='flex'>
              <div className='flex-1 text-15 relative text-black items-center'>
                {!title && <TagItem tag={tag} type={type} />}
                {!!title && <p className='font-[500]'>{title}</p>}
              </div>
              <div className='text-[#666]'>右側領取即享</div>
            </div>
            <div className='flex mt-10 gap-8'>
              {title && <TagItem tag={tag} type={type} />}
              <div className='flex-1 flex flex-col'>
                <div className='flex gap-8 flex-wrap items-center text-12'>
                  {params?.slice(0, 3).map((item: any) => (
                    <div className={`grid gap-6 w-310 mt-2`}>
                      <div className={`${!!item.label ? "pl-30" : ""} inline  relative`}>
                        {!!item.label && (
                          <div className='text-[#999] inline  mr-4 absolute left-0 top-0'>{item.label}:</div>
                        )}
                        <div className='text-black inline'>{item.value}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {params.length < 4 && (
              <div className='w-full text-right text-10 text-[#999] pl-66 flex justify-end'>
                <div className='text-left'>{remark}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

/** 左側信息描述區域 */
const BrandDesc = (props: { kindData: IInquiryKind; isHide?: boolean; activityInfo: any; adBanner?: string }) => {
  const { kindData, isHide, activityInfo, adBanner, type } = props;

  return (
    <div className={`${styles["brand-desc"]} justify-center mt-10`}>
      <div className={styles["brand-thumb"]}>
        {!kindData?.thumb ? (
          <div className={`w-450 h-300 flex justify-center items-center rounded-18 bg-[#F0F6FF] mt-20`}>
            <img
              className='w-214 h-110'
              style={{ width: "216px" }}
              src='https://photo.8891.com.tw/2023/11/01/1698822038777006.png'
            />
          </div>
        ) : (
          <img src={kindData?.thumb} alt='' />
        )}
        <div className={styles["name"]}>
          {kindData?.brandName} {kindData?.kindName}
        </div>
      </div>

      {!!kindData?.brandName && Object.keys(kindData?.factoryDiscount || {}).length > 0 && (
        <DiscountBanner type={type} factoryDiscount={kindData?.factoryDiscount} tcDiscount={kindData?.tcDiscount} />
      )}
    </div>
  );
};

export default BrandDesc;
